import { View, ViewDensity, ViewType } from "@common/types/views/views";
import { RuleDetailsColumn } from "./historyRuleDetailsTableViewConfig";

export const defaultHistoryRuleDetailsView: View = {
    type: ViewType.HISTORY_RULE_DETAILS,
    columns: [
        { id: RuleDetailsColumn.TIME },
        { id: RuleDetailsColumn.GROUP },
        { id: RuleDetailsColumn.STATUS },
        { id: RuleDetailsColumn.CONDITIONS },
        { id: RuleDetailsColumn.ACTIONS },
        {
            id: RuleDetailsColumn.EDIT,
            options: { pin: "right" },
        },
    ],
    filters: {},
    options: {
        selection: true,
        density: ViewDensity.MD,
    },
};
